export default __webpack_public_path__ + "static/byron_filming-030d13e98eccc20fa8d8bf348475be42.jpg";